import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  FormFeedback,
  CustomInput,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import Flatpickr from "react-flatpickr";

//import images
import progileBg from "../../../assets/images/profile-bg.png";
import avatar1 from "../../../assets/images/users/avatar-1.jpg";
import usePersistStoreData from "../../../Components/Hooks/usePersistStoreData";
import { ProfileDetailThunk } from "../../../slices/auth/login/thunk";
import { useDispatch } from "react-redux";
import { maskAccountNumber } from "../../../Components/Hooks/MaskText";
import { useFormik } from "formik";
import * as Yup from "yup";
import EsignConfirmationModal from "../../../Components/Modals/EsignConfirmationModal";
import CommonLoading from "../../../Components/Common/CommonLoading";
import { profile_add_imageThunk } from "../../../slices/thunks";
import { useSelector } from "react-redux";
import { showToast } from "../../../Components/ToastNotification";
import ChangePasswordForm from "./ChangePasswordForm";

const Settings = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  //   console.log("location", location);
  const { userData } = usePersistStoreData();

  const token = userData?.token;
  //   console.log("userData", userData);
  const [loading, setLoading] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [completionPercentage, setCompletionPercentage] = useState(0);
  const [activeTab, setActiveTab] = useState("1");

  const [fillBankForm, setFillBankForm] = useState(false);

  const [passwordShow, setPasswordShow] = useState(false);
  const [micrShow, setMicrShow] = useState(false);
  const [isPrimary, setIsPrimary] = useState(false);

  const [showModal, setShowModal] = useState({
    show: false,
    data: {},
  });

  const [editBank, setEditBank] = useState({});
  // console.log("editBank", editBank);

  const onCloseClick = () => {
    // navigate('/login',{replace:true})
    setShowModal({
      show: false,
      data: {},
    });
  };

  // options for marital status
  const optionMaritalStatus = [
    { key: 1, label: "Single" },
    { key: 2, label: "Married" },
    { key: 3, label: "Divorced" },
    { key: 4, label: "Widowed" },
    { key: 5, label: "Separated" },
  ];
  const maritalStatusLabel = optionMaritalStatus?.find((option) => option?.key === userData?.personal_details?.marital_status)?.label || "";

  

  const validation = useFormik({
    enableReinitialize: true, // Ensures Formik updates when initialValues change
    initialValues: {
      branch: editBank?.name || "",
      bankName: editBank?.name || "",
      accountNumber: editBank?.account_number || "",
      accountType: editBank?.account_type || "",
      ifsc: editBank?.ifsc || "",
      micr: "",
      beneficiary: "",
      isPrimary: editBank?.is_primary || false,
      terms: false,
    },
    validationSchema: Yup.object({
      branch: Yup.string().required("Branch is required!"),
      bankName: Yup.string().required("Bank Name is required!"),
      accountNumber: Yup.string().required("Account Number is required!"),
      accountType: Yup.string().required("Account Type is required!"),
      ifsc: Yup.string().required("IFSC Code is required!"),
      micr: Yup.string().required("MICR Number is required!"),
      beneficiary: Yup.string().required("Beneficiary Name is required!"),
      isPrimary: Yup.boolean(),
      terms: Yup.boolean().oneOf(
        [true],
        "You must accept the Terms & Conditions!"
      ),
    }),
    onSubmit: (values) => {
      // console.log("Form Submitted", values);
    },
  });

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const { profileAddImageLoading } = useSelector(
    (state) => state.Add_Profile_Image
  );

  const [previewUrl, setPreviewUrl] = useState(null);
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
  const ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];

  // When user selects a file
  const onImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!ALLOWED_TYPES.includes(file.type)) {
      showToast("Invalid file type. Only JPEG, JPG, PNG are allowed.", "error");
      return;
    }

    // Validate file size
    if (file.size > MAX_FILE_SIZE) {
      showToast("File too large. Maximum size is 2 MB.", "error");
      return;
    }
    // Store current preview to revert if upload fails
    const previousPreview = previewUrl;

    // Show a preview immediately
    const objectUrl = URL.createObjectURL(file);
    setPreviewUrl(objectUrl);

    const form = new FormData();
    form.append("profile_image", file); // use your backend’s expected key
    dispatch(profile_add_imageThunk({ body: form, token }))
      .unwrap()
      .then(() => showToast("Profile image uploaded successfully.", "success"))
      .catch(() => {
        showToast("Failed to upload profile image.", "error");
        setPreviewUrl(previousPreview);
      });
  };

  useEffect(() => {
    setLoading(true);
    dispatch(ProfileDetailThunk(userData?.token))
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [userData?.token]);

  useEffect(() => {
    if (location?.state?.tab) {
      tabChange(location?.state?.tab);
    }
  }, []);

  useEffect(() => {
    if (userData) {
      const requiredFields = {
        name: userData?.name,
        email: userData?.personal_details?.email,
        phone: userData?.personal_details?.mobile,
        dob: userData?.personal_details?.dob,
        gender: userData?.personal_details?.gender,
        pan: userData?.personal_details?.pan,
        nationality_code: userData?.personal_details?.nationality_code,
        // branch_code: userData?.personal_details?.branch_code,
        // address: userData?.personal_details?.address?.line_one,
        marital_status: userData?.personal_details?.marital_status,
      };

      //   const totalFields = Object.keys(requiredFields).length;
      const totalFields = 10;
      const filledFields = Object.values(requiredFields).filter(Boolean).length;
      const missing = Object.keys(requiredFields).filter(
        (key) => !requiredFields[key]
      );

      setMissingFields(missing);
      setCompletionPercentage(Math.round((filledFields / totalFields) * 100));
    }
    // if (userData?.profile_image) {
    //   setPreviewUrl(userData.profile_image);
    // }
  }, [userData]); // Runs only when userData changes

  // logic to show active exchange data as per true/false condition
 

   // logic to show active exchange data as per true/false condition
   const activeExchanges = Object.entries(
    userData?.trade?.active_exchanges || {}
  )
    .filter(([_, value]) => value) // keep only true
    .map(([key]) => key);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {loading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
          ) : (
            <>
              <div className="position-relative mx-n4 mt-n4">
                <div
                  className="profile-wid-bg profile-setting-img"
                  style={{ backgroundColor: "#01256D" }}
                >
                  {/* <img src={progileBg} className="profile-wid-img" alt="" /> */}
                  <div className="overlay-content">
                    <div className="text-end p-3">
                      <div className="p-0 ps-2 ms-auto rounded-circle profile-photo-edit">
                        <Nav
                          pills
                          className=" animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                          role="tablist"
                        >
                          <NavItem>
                            <NavLink
                              // className={classnames(" ", {
                              //   active: activeTab === "1",
                              // })}
                              onClick={() => {
                                navigate("/profile");
                              }}
                              style={{
                                backgroundColor: "transparent",
                                border: "1px solid #0FA67B",
                              }}
                            >
                              <svg
                                className="me-2"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.99 9L16 9L16 7L3.99 7L3.99 4L3.49691e-07 8L3.99 12L3.99 9Z"
                                  fill="#0FA67B"
                                />
                              </svg>
                              <span className="d-none d-md-inline-block">
                                Go Back
                              </span>
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Row>
                <Col xxl={3} xl={3}>
                  <Card className="mt-n5">
      <CardBody className="p-4">
        {/* Desktop Layout - Hidden on small screens */}
        <div className="d-none d-md-block">
          <div className="text-center border-bottom mb-3">
            <div className="profile-user position-relative d-inline-block mx-auto mb-4">
              <div className={profileAddImageLoading ? "blur-wrapper_profile" : ""}>
                {previewUrl ? (
                  <img
                    src={previewUrl}
                    className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                    alt="user-profile"
                  />
                ) : userData?.profile_image ? (
                  <img
                    src={userData.profile_image}
                    className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                    alt="user-profile"
                  />
                ) : (
                  <i
                    className="mdi mdi-account-circle text-muted"
                    style={{ fontSize: "5rem" }}
                  />
                )}
              </div>
              {profileAddImageLoading && (
                <div className="position-absolute top-50 start-50 translate-middle">
                  <Spinner size="sm" />
                </div>
              )}
            </div>
            <h5 className="fs-16 mb-3">{userData?.name}</h5>
          </div>
          
          {/* Desktop Info Layout */}
          <div className="d-flex flex-column mb-0">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="mb-0 ps-0 fs-p-sm w-50 text-start">Client ID :</p>
              <p className="mb-0 fs-p-sm w-50 text-start">
                {`${userData?.trade?.dp_id}${userData?.trade?.dp_account_number}`}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 ps-0 fs-p-sm w-50 text-start">Mobile Number :</p>
              <p className="mb-0 fs-p-sm w-50 text-start">
                {`+91 ${userData?.personal_details?.mobile}`}
              </p>
            </div>
          </div>
        </div>

        {/* Mobile Layout - Only visible on small screens */}
        <div className="d-block d-md-none">
          {/* Mobile Header with Image and Name side by side */}
          <div className="d-flex align-items-center mb-3">
            <div className="profile-user position-relative me-3">
              <div className={profileAddImageLoading ? "blur-wrapper_profile" : ""}>
                {previewUrl ? (
                  <img
                    src={previewUrl}
                    className="rounded-circle img-thumbnail user-profile-image"
                    alt="user-profile"
                    style={{ width: "60px", height: "60px" }}
                  />
                ) : userData?.profile_image ? (
                  <img
                    src={userData.profile_image}
                    className="rounded-circle img-thumbnail user-profile-image"
                    alt="user-profile"
                    style={{ width: "60px", height: "60px" }}
                  />
                ) : (
                  <i
                    className="mdi mdi-account-circle text-muted"
                    style={{ fontSize: "3.5rem" }}
                  />
                )}
              </div>
              {profileAddImageLoading && (
                <div className="position-absolute top-50 start-50 translate-middle">
                  <Spinner size="sm" />
                </div>
              )}
            </div>
            <div className="flex-grow-1">
              <h5 className="fs-16 mb-0">{userData?.name}</h5>
            </div>
          </div>
          
          {/* Mobile Info Layout - Same as desktop but no border */}
          <div className="d-flex flex-column mb-0">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="mb-0 ps-0 fs-p-sm w-50 text-start">Client ID :</p>
              <p className="mb-0 fs-p-sm w-50 text-start">
                {`${userData?.trade?.dp_id}${userData?.trade?.dp_account_number}`}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 ps-0 fs-p-sm w-50 text-start">Mobile Number :</p>
              <p className="mb-0 fs-p-sm w-50 text-start">
                {`+91 ${userData?.personal_details?.mobile}`}
              </p>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
                
                {userData?.profile_progres === 100 ? (
                <Card>
                <CardBody>
                  <div className="d-flex align-items-center mb-5">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-0">
                        Complete Your Profile
                      </h5>
                    </div>
                    
                  </div>
                  <div className="progress animated-progress custom-progress progress-label">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${userData?.profile_progress}%`,
                        backgroundColor: "#0fa67b",
                      }}
                      aria-valuenow={userData?.profile_progress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div className="label"> {userData?.profile_progress}%</div>
                    </div>
                  </div>
                </CardBody>
              </Card>
                ): null}
                 
                </Col>

                <Col xxl={9} xl={9}>
                  <Card className="mt-xxl-n5 mt-xl-n5">
                    <CardHeader>
                      <Nav
                        className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            to="#"
                            className={classnames("cursor-pointer", {
                              active: activeTab === "1",
                            })}
                            onClick={() => {
                              tabChange("1");
                            }}
                          >
                            <i className="ri-user-line"></i>

                            Personal Details
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            to="#"
                            className={classnames("cursor-pointer", {
                              active: activeTab === "2",
                            })}
                            onClick={() => {
                              tabChange("2");
                            }}
                            type="button"
                          >
                           <i className="ri-apps-2-line"></i>

                            Segment
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            to="#"
                            className={classnames("cursor-pointer", {
                              active: activeTab === "3",
                            })}
                            onClick={() => {
                              tabChange("3");
                            }}
                          >
                           <i className="ri-file-list-3-line"></i>

                            Additional Details
                          </NavLink>
                        </NavItem>

                        {/* <NavItem>
                      <NavLink
                        to="#"
                        className={classnames("cursor-pointer", {
                          active: activeTab === "4",
                        })}
                        onClick={() => {
                          tabChange("4");
                        }}
                        type="button"
                      >
                        <i className="far fa-envelope"></i>
                        Nominee
                      </NavLink>
                    </NavItem> */}
                        <NavItem>
                          <NavLink
                            to="#"
                            className={classnames("cursor-pointer", {
                              active: activeTab === "5",
                            })}
                            onClick={() => {
                              tabChange("5");
                              setFillBankForm(false);
                              setEditBank();
                            }}
                            type="button"
                          >
                          <i className="ri-bank-line"></i>
                            Bank Details
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            to="#"
                            className={classnames("cursor-pointer", {
                              active: activeTab === "6",
                            })}
                            onClick={() => {
                              tabChange("6");
                            }}
                            type="button"
                          >
                            <i className="ri-lock-line"></i>
                            Security & Password
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </CardHeader>
                    <CardBody className="p-4">
                      <TabContent activeTab={activeTab}>
                        {/* Edit personal details */}
                        <TabPane tabId="1">
                          <Form>
                            <Row>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="firstnameInput"
                                    className="form-label"
                                  >
                                    Full Name (Username)
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="firstnameInput"
                                    placeholder="Enter your full name"
                                    defaultValue={userData?.name}
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <Label htmlFor="email" className="form-label">
                                    Email
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="email"
                                    placeholder="Enter your email address"
                                    defaultValue={
                                      userData?.personal_details?.email
                                    }
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="phonenumberInput"
                                    className="form-label"
                                  >
                                    Mobile Number
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="phonenumberInput"
                                    placeholder="Enter your mobile number"
                                    defaultValue={`+91 ${userData?.personal_details?.mobile}`}
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <Label htmlFor="DOB" className="form-label">
                                    Date of Birth (DOB)
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="DOB"
                                    placeholder="Enter your DOB"
                                    defaultValue={
                                      userData?.personal_details?.dob
                                    }
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="Gender"
                                    className="form-label"
                                  >
                                    Gender
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="Gender"
                                    placeholder="Enter your gender"
                                    defaultValue={
                                      userData?.personal_details?.gender
                                    }
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <Label htmlFor="PAN" className="form-label">
                                    PAN
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="PAN"
                                    placeholder="Enter your PAN"
                                    defaultValue={
                                      userData?.personal_details?.pan
                                    }
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="marital_status"
                                    className="form-label"
                                  >
                                    Marital Status
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="marital_status"
                                    placeholder="Enter your marital status"
                                    defaultValue={maritalStatusLabel}
                                    disabled
                                  />
                                </div>
                              </Col>
                              {/* <Col lg={6}>
                            <div className="mb-3">
                              <Label
                                htmlFor="BranchCode"
                                className="form-label"
                              >
                                Branch Code
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                id="BranchCode"
                                placeholder="Enter your Branch Code"
                                defaultValue={
                                  userData?.personal_details?.branch_code
                                }
                                disabled
                              />
                            </div>
                          </Col> */}
                              <div className="mb-3">
                                <span className="badge bg-success p-2 fs-p-sm text-uppercase">
                                  Current Address
                                </span>
                              </div>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="Address"
                                    className="form-label"
                                  >
                                    Address Line
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="Address"
                                    placeholder="Enter your Address"
                                    defaultValue={`${userData?.personal_details?.address?.line_one}, ${userData?.personal_details?.address?.line_two}, ${userData?.personal_details?.address?.line_three}, ${userData?.personal_details?.address?.line_four}`}
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="cityInput"
                                    className="form-label"
                                  >
                                    City
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="cityInput"
                                    placeholder="Enter your city"
                                    defaultValue={
                                      userData?.personal_details?.state
                                    }
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="StateInput"
                                    className="form-label"
                                  >
                                    State
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="StateInput"
                                    placeholder="Enter your State"
                                    defaultValue={
                                      userData?.personal_details?.state
                                    }
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="countryInput"
                                    className="form-label"
                                  >
                                    Country
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="countryInput"
                                    placeholder="Country"
                                    defaultValue="India"
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="zipcodeInput"
                                    className="form-label"
                                  >
                                    Zip Code
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    minLength="5"
                                    maxLength="6"
                                    id="zipcodeInput"
                                    placeholder="Enter zipcode"
                                    defaultValue={
                                      userData?.personal_details?.pincode
                                    }
                                    disabled
                                  />
                                </div>
                              </Col>
                              <div className="mb-3">
                                <span className="badge bg-success p-2 fs-p-sm text-uppercase">
                                  Permanent Address
                                </span>
                              </div>
                              <div className="mb-2">
                                <div class="form-check form-check-success">
                                  <Input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="formCheck8"
                                    checked
                                  />
                                  <Label
                                    class="form-check-label"
                                    for="formCheck8"
                                  >
                                    Same as my current address
                                  </Label>
                                </div>
                              </div>
                              <Col lg={12}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="Address2"
                                    className="form-label"
                                  >
                                    Address Line
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="Address2"
                                    placeholder="Enter your Address"
                                    defaultValue={`${userData?.personal_details?.address?.line_one}, ${userData?.personal_details?.address?.line_two}, ${userData?.personal_details?.address?.line_three}, ${userData?.personal_details?.address?.line_four}`}
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="cityInput2"
                                    className="form-label"
                                  >
                                    City
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="cityInput2"
                                    placeholder="Enter your city"
                                    defaultValue={
                                      userData?.personal_details?.state
                                    }
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="stateInput2"
                                    className="form-label"
                                  >
                                    State
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="stateInput2"
                                    placeholder="Enter your State"
                                    defaultValue={
                                      userData?.personal_details?.state
                                    }
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="countryInput2"
                                    className="form-label"
                                  >
                                    Country
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="countryInput2"
                                    placeholder="Country"
                                    defaultValue="India"
                                    disabled
                                  />
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="mb-3">
                                  <Label
                                    htmlFor="zipcodeInput2"
                                    className="form-label"
                                  >
                                    Zip Code
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    minLength="5"
                                    maxLength="6"
                                    id="zipcodeInput2"
                                    placeholder="Enter zipcode"
                                    defaultValue={
                                      userData?.personal_details?.pincode
                                    }
                                    disabled
                                  />
                                </div>
                              </Col>

                              {/* <Col lg={12}>
                            <div className="hstack gap-2 justify-content-end">
                              <button type="button" className="btn btn-primary">
                                Updates
                              </button>
                              <button
                                type="button"
                                className="btn btn-soft-secondary"
                              >
                                Cancel
                              </button>
                            </div>
                          </Col> */}
                            </Row>
                          </Form>
                        </TabPane>

                        {/* Segment */}
                        <TabPane tabId="2">
                          <div className="row m-0 p-0">
                            <div className=" m-0 p-0 col-xxl-6 col-xl-9 col-lg-8 col-md-8 col-sm-12 col-12">
                              <div className="mb-3">
                                <span className="badge bg-success p-2 fs-p-sm text-uppercase">
                                  Manage Segment
                                </span>
                              </div>
                              {/* <p className="text-muted">
                                Activate or deactivate segment on your account.
                                Once a segment is deactivated, it cannot be
                                activated for the next 12 hours.
                                <span className="text-decoration-underline text-primary ms-1">
                                  {" "}
                                  Learn more.
                                </span>
                              </p> */}
                            </div>
                          </div>
                          {/* <p className="text-muted">
                            Activate or deactivate segment on your account. Once
                            a segment is deactivated, it cannot be activated for
                            the next 12 hours.
                            <span className="text-decoration-underline text-primary ms-1">
                              {" "}
                              Learn more.
                            </span>
                          </p> */}
                        
                      <div className="row m-0 p-0">
                        <div className="m-0 p-0  mb-3 col-xxl-6 col-xl-6 col-lg-8 col-md-8 col-sm-12 col-12">
                        <div className="w-100 d-flex flex-column">
                                      {activeExchanges?.length > 0 ? (
                                        activeExchanges?.map((exchange, i) => (
                                          <div
                                            key={exchange}
                                            className={
                                              i === 0
                                                ? "pb-2 border-bottom d-flex align-items-center justify-content-between"
                                                : i ===
                                                  activeExchanges?.length - 1
                                                ? "pt-2 d-flex align-items-center justify-content-between"
                                                : "py-2 border-bottom d-flex align-items-center justify-content-between"
                                            }
                                          >
                                            <h4 className="text-primary m-0 p-0">
                                              {exchange}
                                            </h4>
                                            <span className="badge bg-success">
                                              Active
                                            </span>
                                          </div>
                                        ))
                                      ) : (
                                        <div className="text-muted text-center py-2">
                                          No active exchange available
                                        </div>
                                      )}
                                    </div>
                        </div>
                      </div>
                    </TabPane>

                    {/* Additional Details */}
                    <TabPane tabId="3">
                      <div className="row m-0 p-0 ">
                        <div className="m-0 p-0 mb-3 col-xxl-6 col-xl-6 col-lg-8 col-md-8 col-sm-12 col-12">
                          <li className="d-flex mb-2">
                            <div className="flex-grow-1">
                              <label
                                htmlFor="directMessage"
                                className="form-check-label fs-14"
                              >
                                DDPI Status
                              </label>
                              {/* <p className="text-muted mb-1">
                                *Note: Only user can activate DDPI.
                              </p> */}
                            </div>
                            <div className="flex-shrink-0">
                              <div className="form-check form-switch form-switch-success form-switch-md">
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="directMessage"
                                  checked={userData?.trade?.ddpi_status}
                                  disabled
                                />
                              </div>
                            </div>
                          </li>

                          <div className="mb-3">
                            <Label
                              htmlFor="zipcodeInput"
                              className="form-label"
                            >
                              Income
                            </Label>
                            <select
                              className="form-control"
                              data-choices
                              data-choices-search-false
                              name="experienceYear"
                              id="experienceYear"
                              value={userData?.trade?.annual_income_bracket}
                              disabled
                            >
                              <option defaultValue="" disabled>
                                Select Income
                              </option>

                              <option value="1">Not available</option>
                              <option value="2">Below 1 lakh</option>
                              <option value="3">1 - 5 lakhs</option>
                              <option value="4">5 - 10 lakhs</option>
                              <option value="5">10 - 25 lakhs</option>
                              <option value="6">25 lakhs - 1 Crore</option>
                              <option value="7">Above 1 Crore</option>
                            </select>
                          </div>
                          </div>
                          </div>
                        </TabPane>
 {/* Bank Details */}
 <TabPane tabId="5">
                          {!fillBankForm && userData?.banking?.length === 0 && (
                            <div className=" m-0">
                              <div className="mb-3">
                                <span className="badge bg-success p-2 fs-p-sm text-uppercase">
                                  Manage Bank Details
                                </span>
                              </div>
                              <p className="text-muted">
                                You haven't added any bank account details to
                                your account yet.
                              </p>
                              <p className="text-muted">
                                Kindly add at least one bank account details.
                                <span className="text-decoration-underline text-primary ms-1">
                                  {" "}
                                  Learn more.
                                </span>
                              </p>
                              <div className="hstack gap-2 justify-content-start">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                >
                                  Add Bank Account
                                </button>
                              </div>
                            </div>
                          )}

                          {!fillBankForm &&
                          userData?.banking?.length > 0 &&
                          userData?.banking?.filter((bank) => bank?.is_primary)
                            ?.length > 0 ? (
                            <div className="">
                              <div className="mb-3">
                                <span className="badge bg-success p-2 fs-p-sm text-uppercase">
                                  Primary Account
                                </span>
                              </div>
                              {userData?.banking
                                ?.filter((bank) => bank?.is_primary)
                                ?.map((el, i) => (
                                  <div
                                    key={i}
                                    className="card card-body px-0 border text-center position-relative mb-3"
                                  >
                                    <Row className=" m-0 p-0">
                                      <Col xxl={4} xl={4} lg={4} sm={12}>
                                        <div className="d-flex flex-column">
                                          <h5 className="mb-1 text-primary text-start me-3">
                                            {el?.name}
                                          </h5>
                                          <p className=" fs-p-sm mb-0 text-start">
                                            Primary Account
                                          </p>
                                        </div>
                                      </Col>
                                      <Col xxl={4} xl={4} lg={4} sm={12}>
                                        <div className="d-flex flex-column">
                                          <p className=" fs-p-sm mb-1 text-muted text-start">
                                            Bank Account Number
                                          </p>
                                          <h5 className="mb-0 text-black text-start fw-medium">
                                            {
                                              el?.account_number
                                            }
                                          </h5>
                                        </div>
                                      </Col>
                                      <Col xxl={4} xl={4} lg={4} sm={12}>
                                        <div className="d-flex flex-column">
                                          <p className=" fs-p-sm mb-1 text-muted text-start">
                                            IFSC
                                          </p>
                                          <h5 className="mb-0 text-black text-start fw-medium">
                                            {el?.ifsc ?? "-"}
                                          </h5>
                                        </div>
                                      </Col>
                                    </Row>
                                    {/* <div
                                  className="cursor-pointer position-absolute"
                                  style={{ top: "15px", right: "15px" }}
                                  onClick={() => {
                                    setEditBank(el);
                                    setFillBankForm(true);
                                  }}
                                >
                                  <i className="mdi mdi-pencil-outline text-muted fs-3"></i>
                                </div> */}
                                  </div>
                                ))}
                              <p className="text-muted">
                                *Note: Only one account can be used as primary
                                account.
                              </p>
                            </div>
                          ) : (
                            !fillBankForm && (
                              <div className=" m-0">
                                <div className="  ">
                                  <div className="mb-3">
                                    <span className="badge bg-success p-2 fs-p-sm text-uppercase">
                                      Primary Account
                                    </span>
                                  </div>
                                  <div className="card card-body border text-center">
                                    <h4 className="text-center">
                                      No Primary Account Selected
                                    </h4>
                                    <p className="mb-0 text-center fs-p-bg">
                                      Kindly select one of your bank account as
                                      primary account.
                                    </p>
                                  </div>
                                  <p className="text-muted">
                                    *Note: Only one account can be used as
                                    primary account.
                                  </p>
                                </div>
                              </div>
                            )
                          )}
                          {!fillBankForm &&
                            userData?.banking?.length > 0 &&
                            userData?.banking?.filter(
                              (bank) => !bank?.is_primary
                            )?.length > 0 && (
                              <div className="">
                                <div className="mb-3">
                                  <span className="badge bg-primary p-2 fs-p-sm text-uppercase">
                                    Secondary Account
                                  </span>
                                </div>
                                {userData?.banking
                                  ?.filter((bank) => !bank?.is_primary)
                                  ?.map((el, i) => (
                                    <div
                                      key={i}
                                      className="card card-body px-0 border text-center position-relative mb-3"
                                    >
                                      <Row className=" m-0 p-0">
                                        <Col xxl={4} xl={4} lg={4} sm={12}>
                                          <div className="d-flex flex-column">
                                            <h5 className="mb-1 text-primary text-start me-3">
                                              {el?.name}
                                            </h5>
                                            <p className=" fs-p-sm mb-0 text-start">
                                              Secondary Account
                                            </p>
                                          </div>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} sm={12}>
                                          <div className="d-flex flex-column">
                                            <p className=" fs-p-sm mb-1 text-muted text-start">
                                              Bank Account Number
                                            </p>
                                            <h5 className="mb-0 text-black text-start fw-medium">
                                              {
                                                el?.account_number
                                              }
                                            </h5>
                                          </div>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} sm={12}>
                                          <div className="d-flex flex-column">
                                            <p className=" fs-p-sm mb-1 text-muted text-start">
                                              IFSC
                                            </p>
                                            <h5 className="mb-0 text-black text-start fw-medium">
                                              {el?.ifsc ?? "-"}
                                            </h5>
                                          </div>
                                        </Col>
                                      </Row>
                                      {/* <div
                                    className="cursor-pointer position-absolute"
                                    style={{ top: "15px", right: "15px" }}
                                    onClick={() => {
                                      setEditBank(el);
                                      setFillBankForm(true);
                                    }}
                                  >
                                    <i className="mdi mdi-pencil-outline text-muted fs-3"></i>
                                  </div> */}
                                    </div>
                                  ))}
                                {/* <div className="hstack gap-2 justify-content-start">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                  setFillBankForm(true);
                                }}
                              >
                                Add Bank Account
                              </button>
                            </div> */}
                              </div>
                            )}

                          {fillBankForm && (
                            <div className=" m-0">
                              <div className="mb-3">
                                <span className="badge bg-success p-2 fs-p-sm text-uppercase">
                                  Manage Bank Details
                                </span>
                              </div>
                              <Form onSubmit={validation.handleSubmit}>
                                <Row>
                                  <Col md={6}>
                                    <FormGroup>
                                      <Label for="branch">Branch</Label>
                                      <Input
                                        type="select"
                                        id="branch"
                                        name="branch"
                                        value={validation.values.branch}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.branch &&
                                          validation.errors.branch
                                        }
                                      >
                                        <option value="">Select Branch</option>
                                        <option value="branch1">
                                          Branch 1
                                        </option>
                                        <option value="branch2">
                                          Branch 2
                                        </option>
                                      </Input>
                                      <FormFeedback>
                                        {validation.errors.branch}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup>
                                      <Label for="bankName">Bank Name</Label>
                                      <Input
                                        type="select"
                                        id="bankName"
                                        name="bankName"
                                        value={validation.values.bankName}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.bankName &&
                                          validation.errors.bankName
                                        }
                                      >
                                        <option value="">Select Bank</option>
                                        <option value="bank1">Bank 1</option>
                                        <option value="bank2">Bank 2</option>
                                      </Input>
                                      <FormFeedback>
                                        {validation.errors.bankName}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup>
                                      <Label for="accountNumber">
                                        Bank Account Number
                                      </Label>
                                      <div className="position-relative auth-pass-inputgroup mb-3">
                                        <Input
                                          name="accountNumber"
                                          value={
                                            validation.values.accountNumber
                                          }
                                          type={
                                            passwordShow ? "text" : "password"
                                          }
                                          className="form-control pe-5"
                                          placeholder="Enter Account Number"
                                          onChange={validation.handleChange}
                                          onBlur={validation.handleBlur}
                                          invalid={
                                            validation.touched.accountNumber &&
                                            validation.errors.accountNumber
                                          }
                                        />
                                        <FormFeedback>
                                          {validation.errors.accountNumber}
                                        </FormFeedback>
                                        <button
                                          className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                          onClick={() =>
                                            setPasswordShow(!passwordShow)
                                          }
                                          type="button"
                                        >
                                          <i className="ri-eye-fill align-middle"></i>
                                        </button>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup>
                                      <Label for="accountType">
                                        Account Type
                                      </Label>
                                      <Input
                                        type="select"
                                        id="accountType"
                                        name="accountType"
                                        value={validation.values.accountType}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.accountType &&
                                          validation.errors.accountType
                                        }
                                      >
                                        <option value="">
                                          Select Account Type
                                        </option>
                                        <option value="saving">Saving</option>
                                        <option value="current">Current</option>
                                      </Input>
                                      <FormFeedback>
                                        {validation.errors.accountType}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>

                                  <Col md={6}>
                                    <FormGroup>
                                      <Label for="accountType">IFSC</Label>
                                      <Input
                                        type="select"
                                        id="accountType"
                                        name="ifsc"
                                        value={validation.values.ifsc}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.ifsc &&
                                          validation.errors.ifsc
                                        }
                                      >
                                        <option value="">Select IFSC</option>
                                      </Input>
                                      <FormFeedback>
                                        {validation.errors.ifsc}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup>
                                      <Label for="micr">MICR Number</Label>
                                      <div className="position-relative auth-pass-inputgroup mb-3">
                                        <Input
                                          name="micr"
                                          value={validation.values.micr}
                                          type={micrShow ? "text" : "password"}
                                          className="form-control pe-5"
                                          placeholder="Enter MICR Number"
                                          onChange={validation.handleChange}
                                          onBlur={validation.handleBlur}
                                          invalid={
                                            validation.touched.micr &&
                                            validation.errors.micr
                                          }
                                        />
                                        <FormFeedback>
                                          {validation.errors.micr}
                                        </FormFeedback>
                                        <button
                                          className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                          onClick={() => setMicrShow(!micrShow)}
                                          type="button"
                                        >
                                          <i className="ri-eye-fill align-middle"></i>
                                        </button>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  <Col md={12}>
                                    <FormGroup>
                                      <Label for="beneficiary">
                                        Beneficiary Full Name
                                      </Label>
                                      <Input
                                        type="text"
                                        id="beneficiary"
                                        name="beneficiary"
                                        value={validation.values.beneficiary}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.touched.beneficiary &&
                                          validation.errors.beneficiary
                                        }
                                      />
                                      <FormFeedback>
                                        {validation.errors.beneficiary}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col xxl={6} xl={9} lg={12} md={12} sm={12}>
                                    <div className="form-switch form-check form-switch-success form-switch-md p-0 m-0 d-flex align-items-center justify-content-between">
                                      <Label for="isPrimary" check>
                                        Do you want to use this bank as a
                                        primary account?*
                                      </Label>
                                      <Input
                                        type="switch"
                                        color="success"
                                        id="isPrimary"
                                        name="isPrimary"
                                        className="form-check form-switch form-switch-success form-switch-md"
                                        checked={validation.values.isPrimary}
                                        onChange={(e) => {
                                          validation.setFieldValue(
                                            "isPrimary",
                                            !validation.values.isPrimary
                                          );
                                          //   console.log("e",e.target.checked)
                                          if (e.target.checked) {
                                            setShowModal({
                                              show: true,
                                              data: {},
                                            });
                                          } else {
                                            return;
                                          }
                                        }}
                                      />
                                    </div>
                                  </Col>
                                  <p className="text-muted my-2">
                                    *Note: Setting bank preference as Primary
                                    requires E-Sign Verification.
                                    <a href="#" className="fw-semibold">
                                      {" "}
                                      Learn More
                                    </a>
                                    .
                                  </p>
                                  <p className="text-muted">
                                    *Note: Only one account can be used as
                                    primary account.
                                  </p>
                                  <Col md={12}>
                                    <FormGroup check>
                                      <Label check>
                                        <Input
                                          type="checkbox"
                                          name="terms"
                                          checked={validation.values.terms}
                                          onChange={validation.handleChange}
                                          invalid={
                                            validation.touched.terms &&
                                            validation.errors.terms
                                          }
                                        />
                                        I accept the Terms & Conditions.{" "}
                                        <a href="#" className="fw-semibold">
                                          {" "}
                                          Learn More
                                        </a>
                                        .
                                      </Label>
                                      <FormFeedback>
                                        {validation.errors.terms}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col md={12} className="mt-3">
                                    <div className="hstack gap-2 justify-content-start">
                                      <Button
                                        disabled={!validation?.values?.terms}
                                        color="primary"
                                        type="submit"
                                      >
                                        Save Bank Details
                                      </Button>
                                      <button
                                        type="button"
                                        className="btn btn-soft-secondary"
                                        onClick={() => {
                                          setFillBankForm(false);
                                          setEditBank();
                                        }}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </div>
                          )}
                        </TabPane>
                       

                    {/* Change Password */}
                    <TabPane tabId="6">
                    <ChangePasswordForm />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
          </>
              )}
        </Container>
      </div>
      {showModal?.show && (
        <EsignConfirmationModal
          showModal={showModal}
          onCloseClick={onCloseClick}
        />
      )}
    </React.Fragment>
  );
};

export default Settings;
